import React, { FC, useState, MouseEvent } from 'react'

import { Icon, Txt } from 'src/components/atoms'
import { MenuItem } from 'src/components/atoms/dataDisplays/Menu'
import { DeleteProjectModal } from 'src/components/organisms'

type Props = {
  targetProjectIds: string[]
  disabled?: boolean
  className?: string
}

export const DeleteProjectMenuItem: FC<Props> = ({ targetProjectIds, disabled, className }) => {
  const [showModal, setShowModal] = useState(false)

  const handleOnClickDelete = async (event: MouseEvent) => {
    event.preventDefault()
    setShowModal(true)
  }

  return (
    <MenuItem
      isSelectable
      onClick={event => !disabled && handleOnClickDelete(event)}
      disabled={disabled}
      className={className}
    >
      <div className="tw-flex tw-gap-s-2 tw-items-center tw-w-full">
        <Icon size="--r2" path="trash/soft/line" />
        <Txt>プロジェクト削除</Txt>
      </div>

      <DeleteProjectModal
        projectIds={targetProjectIds}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </MenuItem>
  )
}
